/** @file Constrained Delaunay mesh of a polygon and interior points (ear clipping, insertion, flips). */
import { delaunayFlips } from './delaunayFlips';
import { earClip } from './earClip';
import { insertPoints } from './insertPoints';

/** Triangles of a mesh and which input points they use. */
export interface Triangulation {
  /** Counter-clockwise (y-up) index triples into `kept`. */
  triangles: number[];
  /** Input point indices in output order: 0..hullCount−1 first, then the interior points that were inserted. */
  kept: number[];
}

/** Triangulates the counter-clockwise simple polygon of points 0..hullCount−1 of `p`; later points are interior candidates. */
export function triangulate(p: ArrayLike<number>, hullCount: number): Triangulation {
  const { triangles, skipped } = insertPoints(p, hullCount, earClip(p, hullCount));
  delaunayFlips(p, triangles, hullCount);
  const dropped = new Set(skipped);
  const kept: number[] = [];
  const remap = new Int32Array(p.length / 2).fill(-1);
  for (let i = 0; i < p.length / 2; i++) {
    if (dropped.has(i)) continue;
    remap[i] = kept.length;
    kept.push(i);
  }
  return { triangles: triangles.map((v) => remap[v] ?? -1), kept };
}
